import React, { useEffect, useState } from "react";
// @material-ui/core components
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  makeStyles,
  Slide,
  TextField,
  useTheme,
} from "@material-ui/core";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";
import { Autocomplete } from "@material-ui/lab";
import moment from "moment";
import { UpdateOrderAPI } from "../../config/api.js";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};
const columns = [
  { id: "product", label: "Product" },
  { id: "discountPercent", label: "Discount Percent" },
  { 
    id: "discountAmount", 
    label: "Discount Amount",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
];
const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function OrderEdit(props) {
  const classes = useStyles();
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const authToken = useSelector((state) => state.userReducer.authToken);

  const theme = useTheme();
  const { open, close, item, closeCompanyOrderView } = props;
  let {
    orderType,
    party,
    orderNo,
    price,
    code,
    orderDetail,
    orderReturnStatus,
    orderAdminStatus,
    orderAdminDetails,
    orderReturnCustomerDetails,
    orderReturnAdminDetails,
  } = item;
  const {
    rLens,
    lLens,
    rRate,
    lRate,
    fitter,
    fitting,
    amount,
    lab,
    given,
    received,
    partyRef,
    productName,
    productType,
    cg,
    dia,
    prism,
    coat,
    color,
    type,
    brand,
    design,
    tint,
    rSph,
    lSph,
    lCyl,
    rCyl,
    rAxis,
    lAxis,
    rAddition,
    lAddition,
    ed,
    pd,
    rBlank,
    lBlank,
    labName,
    labRecvd,
    labAmount,
    arcName,
    arcType,
    arcAmount,
    fittingName,
    fittingType,
    fittingGiven,
    fittingRecvd,
    fittingAmount,
    fittingHeight,
    index,
    urgent,
    frameSection,
    oTaken,
    delivered,
    tintAmount,
    others,
    note,
    challanCreated,
  } = orderDetail;



  const [quantity, setQuantity] = useState(item?.quantity ? item.quantity : "");
  async function _onUpdate(code) {
    try {
      let res = await axios.patch(
        UpdateOrderAPI(code),
        {
          quantity: quantity,
          orderAmount: parseInt(quantity) * parseInt(price),
          orderDetail: { ...orderDetail, quantity: quantity }
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      close();
      closeCompanyOrderView();
    } catch (err) {
      // console.log(err);

    }
  }

  return (
    <Dialog
      // fullScreen={false}
      // fullWidth
      fullScreen
      maxWidth={"lg"}
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <GridContainer>
        <GridItem xs={12} sm={12}>
          <Card>
            <CardHeader color="primary">
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <h4 className={classes.cardTitleWhite}>Order Detail</h4>
                <Box sx={{ display: "flex" }}>
                  <Button style={{ color: "white" }} onClick={close}>
                    Close
                  </Button>
                  <Button style={{ color: "white" }} onClick={() => _onUpdate(code)}>
                    Save
                  </Button>
                </Box>

              </Box>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    labelText="Order Type"
                    id="orderType"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: orderType,
                    }}
                  />
                </GridItem>
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="R Lens"
                      id="rLens"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: rLens,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="L Lens"
                      id="lLens"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: lLens,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="R Rate"
                      id="rRate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: rRate,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="L Rate"
                      id="lrate"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: lRate,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="Fitter"
                      id="fitter"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: fitter,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={2}>
                    <CustomInput
                      labelText="Fitting"
                      id="fitting"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: fitting,
                      }}
                    />
                  </GridItem>
                )}
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    labelText="Order No"
                    id="orderNo"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: orderNo,
                    }}
                  />
                </GridItem>
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="Given"
                      id="given"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: moment(given).format("DD-MM-YY "),
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText={"Received"}
                      id="Received"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: moment(received).format("DD-MM-YY"),
                      }}
                    />
                  </GridItem>
                )}

                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="Lab"
                      id="lab"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: lab,
                      }}
                    />
                  </GridItem>
                )}
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="productName"
                    id="productName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: productName,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    labelText={"Quantity"}
                    id="quantity"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: quantity,
                      onChange: (event) => setQuantity(event.target.value),
                    }}
                  />
                </GridItem>

                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText={"Rate"}
                      id="amount"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: amount,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText={"Rate"}
                      id="amount"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: price,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="productType"
                      id="productType"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: productType,
                      }}
                    />
                  </GridItem>
                )}
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Party"
                    id="party"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: party.accountName,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Party Reference"
                    id="partyRef"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: partyRef,
                    }}
                  />
                </GridItem>
                {orderType === "Fitting" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="Cr/Gl/P"
                      id="cg"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: cg,
                      }}
                    />
                  </GridItem>
                )}
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    labelText="Dia/Ed"
                    id="dia"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: dia,
                    }}
                  />
                </GridItem>
                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="prism"
                      id="prism"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: prism,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="Coat"
                      id="coat"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: coat,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="ed"
                      id="ed"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: ed,
                      }}
                    />
                  </GridItem>
                )}
                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText="pd"
                      id="pd"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: pd,
                      }}
                    />
                  </GridItem>
                )}
                {/* {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Brand"
                      id="brand"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
disabled: true,
                        value: brand,
                        
                      }}
                    />
                  </GridItem>
                )} */}
                {/* {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Design"
                      id="design"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
disabled: true,
                        value: design,
                        
                      }}
                    />
                  </GridItem>
                )} */}

                {orderType === "Prescription" && (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={1}
                    style={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={tint}
                          disabledd
                          name="tint"
                          color={"primary"}
                        />
                      }
                      label="Tint"
                    />
                  </GridItem>
                )}
                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText={"Fitting Height"}
                      id="fittingHeight"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: fittingHeight,
                      }}
                    />
                  </GridItem>
                )}

                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText={"Index"}
                      id="index"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: index,
                      }}
                    />
                  </GridItem>
                )}

                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={1}>
                    <CustomInput
                      labelText={"Frame Section"}
                      id="frameSection"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        value: frameSection,
                      }}
                    />
                  </GridItem>
                )}

                {orderType === "Prescription" && (
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText={"Notes"}
                      id="note"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: true,
                        rows: 1,
                        multiline: true,
                        value: note,
                      }}
                    />
                  </GridItem>
                )}
                {/* {orderType === "Prescription" && ( */}
                <GridItem xs={12} sm={12} md={1}></GridItem>
                {/* )} */}
                <GridItem xs={12} sm={12} md={1}>
                  <p>Sph</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <p>Cyl</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <p>Axis</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <p>Add</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={7}></GridItem>
                <GridItem
                  xs={12}
                  sm={12}
                  md={1}
                  style={{ display: "flex", alignItems: "flex-end" }}
                >
                  <p>Right</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="rSph"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: rSph,
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="rCyl"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: rCyl,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="rAxis"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: rAxis,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="rAddition"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: rAddition,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={7}></GridItem>
                <GridItem
                  xs={12}
                  sm={12}
                  md={1}
                  style={{ display: "flex", alignItems: "flex-end" }}
                >
                  <p>Left</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="lSph"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: lSph,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="lCyl"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: lCyl,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="lAxis"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: lAxis,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={1}>
                  <CustomInput
                    id="lAddition"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: lAddition,
                    }}
                  />
                </GridItem>
                {/* <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText={"R Blank"}
                    id="rBlank"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: rBlank,
                      
                    }}
                  />
                </GridItem> */}
                {/* <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText={"L Blank"}
                    id="lBlank"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: lBlank,
                      
                    }}
                  />
                </GridItem> */}
                {/* <GridItem xs={12} sm={12} md={2}></GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <p>Name</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <p>Type</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <p>Given</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <p>Recvd</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <p>Amt</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <p>Lab</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="labName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: labName,
                      
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}></GridItem>
                <GridItem xs={12} sm={12} md={2}></GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="labRecvd"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: labRecvd,
                      
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="labAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: labAmount,
                      
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <p>A R C</p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="arcName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: arcName,
                      
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="arcType"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: arcType,
                      
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}></GridItem>
                <GridItem xs={12} sm={12} md={2}></GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="arcAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: arcAmount,
                      
                    }}
                  />
                </GridItem> */}

                {/* <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="fittingName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: fittingName,
                      
                    }}
                  />
                </GridItem> */}
                {/* <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="fittingType"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: fittingType,
                      
                    }}
                  />
                </GridItem> */}
                {/* <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="fittingGiven"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: fittingGiven,
                      
                    }}
                  />
                </GridItem> */}
                {/* <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    id="fittingRecvd"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: fittingRecvd,
                      
                    }}
                  />
                </GridItem> */}

                {/* <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText={"Tint Amount"}
                    id="tintAmount"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: tintAmount,
                      
                    }}
                  />
                </GridItem> */}
                {/* <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText={"Others"}
                    id="others"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
disabled: true,
                      value: others,
                      
                    }}
                  />
                </GridItem> */}

                {orderType === "Prescription" &&
                  orderAdminStatus !== "Pending" && (
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={"Order Admin Details"}
                        id="note"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          rows: 1,
                          multiline: true,
                          value: orderAdminDetails,
                        }}
                      />
                    </GridItem>
                  )}

                {orderType === "Prescription" &&
                  orderReturnStatus !== "None" && (
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={"Order Return Customer Details"}
                        id="note"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          rows: 1,
                          multiline: true,
                          value: orderReturnCustomerDetails,
                        }}
                      />
                    </GridItem>
                  )}

                {orderType === "Prescription" &&
                  orderReturnStatus !== "Pending" &&
                  orderAdminStatus !== "Pending" && (
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText={"Order Return Admin Details"}
                        id="note"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          disabled: true,
                          rows: 1,
                          multiline: true,
                          value: orderReturnAdminDetails,
                        }}
                      />
                    </GridItem>
                  )}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Dialog>
  );
}
